import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCurrentLineStartDate = createSelector(
  (state: Store) => state.dealManagement.commonDeal.currentLine.startDate,
  (startDate) => startDate,
);

export const getCurrentLineEndDate = createSelector(
  (state: Store) => state.dealManagement.commonDeal.currentLine.endDate,
  (endDate) => endDate,
);
